angular.module("MessageNotificationApp").directive('messageNotification', ['$parse', function ($parse) {
    return {
        restrict: 'E',
        templateUrl: '/static/assets/khapps/message_notification/partials/message_notification_in_form.html',
        scope: true
    };
}]);